module.exports = __webpack_public_path__ + "img/logo.e8174d8a.png";